/* eslint-disable max-len */
import React from 'react';

export const MainLazy = React.lazy(() => import('../../views/main/Main' /* webpackChunkName: "main" */ /* webpackPrefetch: true */));
export const SinglePageSwitchLazy = React.lazy(() => import('../../views/single-page-switch/SinglePageSwitch' /* webpackChunkName: "main" */ /* webpackPrefetch: true */));
export const OrderConfirmationLazy = React.lazy(() => import('../../views/order-confirmation/OrderConfirmation' /* webpackChunkName: "main" */ /* webpackPrefetch: true */));
export const Auth0CallbackGuestLazy = React.lazy(() => import('../../views/auth0-callback/Auth0CallbackGuest' /* webpackChunkName: "main" */ /* webpackPrefetch: true */));
export const Auth0CallbackAuthenticatedLazy = React.lazy(() => import('../../views/auth0-callback/Auth0CallbackAuthenticated' /* webpackChunkName: "main" */ /* webpackPrefetch: true */));
export const Auth0CallbackOrderClaimLazy = React.lazy(() => import('../../views/auth0-callback/Auth0CallbackOrderClaim' /* webpackChunkName: "main" */ /* webpackPrefetch: true */));
export const Auth0CallbackCreateAccountLazy = React.lazy(() => import('../../views/auth0-callback/Auth0CallbackCreateAccount' /* webpackChunkName: "main" */ /* webpackPrefetch: true */));

export const INTERNATIONAL_PHONE_NUMBER = { id: 'phoneNumber', name: 'phoneNumber' };
export function InternationalPhoneNumberLoader() {

  const cache = {
    isLoading: false,
    placeholder: INTERNATIONAL_PHONE_NUMBER,
  };

  return function lazy({
    onComplete = () => null,
    onError = () => null,
  } = {}) {

    if (cache.module) {
      return cache.module;
    }

    if (cache.isLoading) {
      return cache.placeholder;
    }

    cache.isLoading = true;

    // console.warn('========== LAZY INT PHONE NUMBER MODULE');

    import('jl-design-system/form/fields/internationalPhoneNumber' /* webpackPrefetch: true */ /* webpackChunkName: "main" */).then((module) => {
      // console.warn('========== LAZY INT PHONE NUMBER LOADED');
      cache.module = module.default;
      cache.isLoading = false;
      onComplete();
    }).catch((error) => {
      /* eslint-disable no-console */
      console.warn('========== LAZY MODULE ERROR', error);
      cache.isLoading = false;
      onError();
    });

    return cache.placeholder;
  };

}

export const internationalPhoneNumberLazy = new InternationalPhoneNumberLoader();
